import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useMutation, useQuery } from '@apollo/client'
import { SAVE_TEAM_CONFIGURATION } from '../../../graphql/mutation'
import { toast } from 'react-toastify'
import { GET_ALL_EXTERNAL_SERVICES, GET_TEAMS_CONFIG_BY_BG_ACCOUNT } from '../../../graphql/query'
import { usePlan } from '../../../context/PlanContext'

interface IProps {
  closeTeamsModal: () => void
}
const TeamsModal: React.FC<IProps> = ({ closeTeamsModal }) => {
  const { currentPlan } = usePlan()
  const [initialValues, setInitialValues] = useState<any>({
    clientId: '',
    clientSecret: '',
    tenantId: '',
    externalServiceId: null,
    redirectUrl: '',
    scope: ''
  })
  const { data: TeamsData, refetch } = useQuery(GET_TEAMS_CONFIG_BY_BG_ACCOUNT, {
    variables: {
      input: {
        bgAccountId: currentPlan?.bgAccountId
      }
    }
  })

  const [saveTeamsConfiguration] = useMutation(SAVE_TEAM_CONFIGURATION, {
    context: { headers: { 'access-control-allow-methods': 'Configuration' } }
  })

  const { data } = useQuery(GET_ALL_EXTERNAL_SERVICES)

  const teamsService = data?.getAllExternalServices?.find(
    (service: any) => service.name.toLowerCase() === 'teams'
  )
  const teamsServiceId = teamsService ? teamsService.id : 0

  // const initialValues = {
  //   clientid: TeamsData?.getTeamsConfigByBgAccountId?.[0]?.clientId || '',
  //   clientSecret: TeamsData?.getTeamsConfigByBgAccountId?.[0]?.clientSecret || '',
  //   tenantId: TeamsData?.getTeamsConfigByBgAccountId?.[0]?.tenantId || '',
  //   externalServiceId:
  //     TeamsData?.getTeamsConfigByBgAccountId?.[0]?.externalServiceId || teamsServiceId,
  //   scope: TeamsData?.getTeamsConfigByBgAccountId?.[0]?.scope || '',
  //   redirectUrl: TeamsData?.getTeamsConfigByBgAccountId?.[0]?.redirectUri || ''
  // }

  const validationSchema = Yup.object({
    clientid: Yup.string().required('Client id is required'),
    tenantId: Yup.string().required('Tenant id is required'),
    clientSecret: Yup.string().required('Client secret id is required'),
    externalServiceId: Yup.number()
      .required('External service id is required')
      .min(1, 'Must be greater than 0'),
    scope: Yup.string().required('scope is required'),
    redirectUrl: Yup.string().required('Redirect url is required')
  })

  useEffect(() => {
    if (TeamsData) {
      console.log(teamsServiceId)
      setInitialValues({
        clientid: TeamsData?.getTeamsConfigByBgAccountId?.[0]?.clientId || '',
        clientSecret: TeamsData?.getTeamsConfigByBgAccountId?.[0]?.clientSecret || '',
        tenantId: TeamsData?.getTeamsConfigByBgAccountId?.[0]?.tenantId || '',
        externalServiceId:
          TeamsData?.getTeamsConfigByBgAccountId?.[0]?.externalServiceId || teamsServiceId,
        scope: TeamsData?.getTeamsConfigByBgAccountId?.[0]?.scope || '',
        redirectUrl: TeamsData?.getTeamsConfigByBgAccountId?.[0]?.redirectUri || ''
      })
    }
  }, [TeamsData, teamsServiceId])

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      saveTeamsConfiguration({
        variables: {
          input: {
            externalServiceId: teamsServiceId,
            clientId: values.clientid,
            clientSecret: values.clientSecret,
            tenantId: values.tenantId,
            scope: values.scope,
            redirectUri: values.redirectUrl
          }
        }
      })
        .then((res: any) => {
          closeTeamsModal()
          if (
            res.data.saveTeamsConfiguration.status >= 200 &&
            res.data.saveTeamsConfiguration.status < 300
          ) {
            toast.success(res.data.saveTeamsConfiguration.message)
          } else {
            toast.error(res.data.saveTeamsConfiguration.message)
          }
          refetch()
        })
        .catch((err) => {
          closeTeamsModal()
          toast.error('Sorry! Unexpected Error.')
          console.error(err)
        })
    }
  })

  console.log(teamsServiceId, 'teamsServiceId')

  return (
    <div className='collapse show'>
      <form className='form' onSubmit={formik.handleSubmit}>
        {formik.status && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>{formik.status}</div>
          </div>
        )}

        <div className='d-flex justify-content-between align-items-center px-3 py-2'>
          <h2 className='mb-0'>Microsoft Teams Configuration</h2>
        </div>

        <div className='d-flex justify-content-between align-items-center px-3 py-2'>
          <p className='mb-0'>Please fill out all the required fields below.</p>
        </div>
        <div className='card-body p-9'>
          <div className='row mb-3'>
            <label className='col-form-label required fw-semibold fs-6'>Client ID</label>
            <div className='fv-row'>
              <input
                type='text'
                {...formik.getFieldProps('clientid')}
                className={clsx('form-control form-control-lg form-control-solid', {
                  'is-invalid': formik.touched.clientid && formik.errors.clientid
                })}
                placeholder='Client Id'
              />
              {formik.touched.clientid && formik.errors.clientid && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{String(formik.errors.clientid)}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className='row mb-3'>
            <label className='col-form-label required fw-semibold fs-6'>Tenant ID</label>
            <div className='fv-row'>
              <input
                type='text'
                {...formik.getFieldProps('tenantId')}
                className={clsx('form-control form-control-lg form-control-solid', {
                  'is-invalid': formik.touched.tenantId && formik.errors.tenantId
                })}
                placeholder='Tenant Id'
              />
              {formik.touched.tenantId && formik.errors.tenantId && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{String(formik.errors.tenantId)}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className='row mb-3'>
            <label className='col-form-label required fw-semibold fs-6'>Client Secret Id</label>
            <div className='fv-row'>
              <input
                type='text'
                {...formik.getFieldProps('clientSecret')}
                className={clsx('form-control form-control-lg form-control-solid', {
                  'is-invalid': formik.touched.clientSecret && formik.errors.clientSecret
                })}
                placeholder='Client secret Id'
              />
              {formik.touched.clientSecret && formik.errors.clientSecret && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{String(formik.errors.clientSecret)}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className='row mb-3'>
            <label className='col-form-label required fw-semibold fs-6'>Scope</label>
            <div className='fv-row'>
              <input
                type='text'
                {...formik.getFieldProps('scope')}
                className={clsx('form-control form-control-lg form-control-solid', {
                  'is-invalid': formik.touched.scope && formik.errors.scope
                })}
                placeholder='Scope'
              />
              {formik.touched.scope && formik.errors.scope && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{String(formik.errors.scope)}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className='row mb-3'>
            <label className='col-form-label required fw-semibold fs-6'>Redirect Url</label>
            <div className='fv-row'>
              <input
                type='text'
                {...formik.getFieldProps('redirectUrl')}
                className={clsx('form-control form-control-lg form-control-solid', {
                  'is-invalid': formik.touched.redirectUrl && formik.errors.redirectUrl
                })}
                placeholder='Redirect url'
              />
              {formik.touched.redirectUrl && formik.errors.redirectUrl && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{String(formik.errors.redirectUrl)}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className='d-flex justify-content-end mt-4'>
            <button type='button' className='btn btn-secondary me-4' onClick={closeTeamsModal}>
              Cancel
            </button>
            <button type='submit' className='btn btn-sm btn-primary' disabled={formik.isSubmitting}>
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default TeamsModal
